export const iconFontAwesomeArrowsArrowUpShortWide = (
	<i className="fa-solid fa-arrow-up-short-wide"></i>
);
